<div class="mt-6" [formGroup]="formGroup">
  <div class="flex flex-row">
    <span
      class="text-md font-semibold mb-3 card-title"
      [ngClass]="{ required: fields.isRequired }"
    >
      {{ fields.displayName }}
    </span>
  </div>

  <!--  Skeleton -->
  <div
    class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-5 lg:gap-7.5 mt-6"
    *ngIf="isLoading"
  >
    <div
      *ngFor="let i of skeletonArray"
      class="relative border rounded-xl p-5 flex items-start gap-4 bg-white dark:bg-coal-700"
    >
      <!-- Logo -->
      <div
        class="w-10 h-10 rounded-circle shimmer-item bg-gray-300 dark:bg-coal-700"
      ></div>

      <!-- Text -->
      <div class="flex flex-col gap-2 flex-1">
        <div
          class="w-36 h-4 rounded shimmer-item bg-gray-300 dark:bg-coal-700"
        ></div>
        <div
          class="w-48 h-4 rounded shimmer-item bg-gray-300 dark:bg-coal-700"
        ></div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isLoading"
    class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-5 lg:gap-7.5 mt-6"
    [ngClass]="{ cardScroll: fieldsData?.length > 5 }"
  >
    <ng-container *ngFor="let option of fieldsData">
      <div
        (click)="toggleSelection(option)"
        [ngClass]="{
          'border-success border-3': isSelected(option),
          'border-gray-300': !isSelected(option),
        }"
        class="relative flex flex-row items-start gap-3 px-3 pb-3 border bg-no-repeat bg-cover rounded-md h-[110px] overflow-hidden cursor-pointer [&.dark]:bg-coal-600 hover:bg-secondary-active"
        style="padding-top: 1.75rem"
      >
        <!-- Check icon — absolutely positioned, doesn't affect layout -->
        <i
          class="ki-solid ki-check-circle absolute top-2 left-2 text-xl text-success transition-opacity duration-200"
          [ngClass]="{
            'opacity-100': isSelected(option),
            'opacity-0': !isSelected(option),
          }"
        ></i>
        <div class="mt-1 flex flex-row gap-1">
          <!-- Icon -->
          <div class="relative size-[44px] shrink-0">
            <img
              [src]="option.iconUrl || './assets/media/data-view/locations.png'"
              class="w-[44px] h-[44px] object-contain"
            />
          </div>

          <!-- Text -->
          <div class="flex flex-col min-w-0 flex-1 overflow-hidden">
            <a
              class="text-sm font-semibold text-gray-900 hover:text-primary-active truncate block"
              [title]="
                fields?.options?.source?.formID === '6a3d163923bf07d3d695d993'
                  ? option.shortName
                  : option.name
              "
            >
              <ng-container
                *ngIf="
                  fields?.options?.source?.formID ===
                    '6a3d163923bf07d3d695d993';
                  else defaultName
                "
              >
                {{ option.shortName }}
              </ng-container>
              <ng-template #defaultName>
                {{ option.name }}
              </ng-template>
            </a>
            <span
              *ngIf="
                fields?.options?.source?.formID === '6a3d163923bf07d3d695d993'
                  ? option.fullName
                  : option.subText
              "
              class="text-xs font-medium text-gray-500 mt-0.5 card-subtext-clamp"
              [title]="
                fields?.options?.source?.formID === '6a3d163923bf07d3d695d993'
                  ? option.fullName
                  : option.subText
              "
            >
              {{
                fields?.options?.source?.formID === "6a3d163923bf07d3d695d993"
                  ? option.fullName
                  : option.subText
              }}
            </span>
            <a
              *ngIf="option.key"
              class="text-xs font-medium text-gray-500 truncate block mt-0.5"
              [title]="option.key"
            >
              {{ option.key }}
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="showValidationError" class="text-sm text-danger mt-2">
  Please select an option.
</div>

<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'checkbox_type_one_modal_' + fields.fieldName"
>
  <div
    class="modal-content other-framework-modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg bg-white shadow-lg dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="card-title font-semibold text-base ms-2">
        Other Frameworks
      </span>
      
    </div>
    <div class="modal-body other-framework-modal-body gap-5 p-4">
      <div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-2">
        <p class="text-sm text-gray-600 mb-3">
          Select the frameworks you want to add. Search for a framework by name.
        </p>
        <div class="sticky top-0 z-10 bg-white dark:bg-coal-600 mb-1">
          <div class="flex search-wrapper rounded">
            <label class="input input-sm">
              <i class="ki-filled ki-magnifier"> </i>
              <input
                searchInput
                type="text"
                #searchInput
                (input)="onKeyUpSearch(searchInput.value)"
                class="w-full text-2sm p-2"
                [value]="otherFrameworkSearchText"
                [placeholder]="fields.placeholder"
              />
              <button
                *ngIf="otherFrameworkSearchText"
                type="button"
                class="clear-btn text-xl"
                (click)="searchInput.value = ''; onKeyUpSearch('')"
              >
                ×
              </button>
            </label>
          </div>
        </div>
        <div class="other-framework-list mt-4">
          <!-- ✅ SKELETON -->
          <div class="user-skeleton-list" *ngIf="isOtherFrameworkLoading">
            <div class="user-skeleton-row" *ngFor="let i of [1, 2, 3, 4, 5]">
              <div
                class="avatar shimmer-item bg-gray-300 dark:bg-coal-700"
              ></div>

              <div class="details">
                <div
                  class="name shimmer-item bg-gray-300 dark:bg-coal-700"
                ></div>
                <div
                  class="email shimmer-item bg-gray-300 dark:bg-coal-700"
                ></div>
              </div>

              <div
                class="radio shimmer-item bg-gray-300 dark:bg-coal-700"
              ></div>
            </div>
          </div>
          <ng-container
            *ngIf="
              hasOtherFrameworkSearch &&
              otherFrameworksData.length === 0 &&
              !isOtherFrameworkLoading
            "
          >
            <div class="flex justify-center items-center h-full w-full">
              <div class="flex justify-center items-center flex-col">
                <img
                  src="./assets/media/icons/no-data.png"
                  class="h-[100px] w-[100px]"
                />
                <span class="text-md text-center card-title"
                  >No data found</span
                >
                <span class="text-xs text-center text-gray-400"
                  >There is no data to show you right now.</span
                >
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              hasOtherFrameworkSearch &&
              otherFrameworksData.length > 0 &&
              !isOtherFrameworkLoading
            "
          >
            <div
              *ngFor="let option of otherFrameworksData; let i = index"
              class="border-b border-gray-200 last:border-b-0 dark:border-gray-700"
            >
              <label
                class="flex items-center justify-between gap-3 cursor-pointer rounded-md transition-colors duration-200 hover:bg-secondary-active p-2"
              >
                <!-- Profile & Info -->
                <div class="flex items-center gap-2 ms-3" *ngIf="option.name">
                  <div class="flex flex-col">
                    <span class="font-semibold text-md text-gray-900">
                      {{ option.name }}
                    </span>
                    <span *ngIf="option.subText" class="text-sm text-gray-500">
                      {{ option.subText }}
                    </span>
                  </div>
                </div>
                <input
                  type="checkbox"
                  class="checkbox checkbox-sm shrink-0"
                  [checked]="isSelected(option)"
                  (change)="toggleSelection(option)"
                />
              </label>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
